import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export const useMediaOwnerCheck = () => {
  const { user, loading } = useAuth();
  const [isMediaOwner, setIsMediaOwner] = useState(false);
  const [mediaOwnerName, setMediaOwnerName] = useState<string | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkMediaOwnerStatus = async () => {
      if (!user?.email) {
        setIsMediaOwner(false);
        setMediaOwnerName(null);
        setChecking(false);
        return;
      }

      try {
        const { data, error } = await supabase.rpc('get_media_owner_for_email', {
          p_email: user.email,
        });

        if (error) {
          console.error('Error checking media owner status:', error);
          setIsMediaOwner(false);
          setMediaOwnerName(null);
        } else if (data) {
          setIsMediaOwner(true);
          setMediaOwnerName(data);
        } else {
          setIsMediaOwner(false);
          setMediaOwnerName(null);
        }
      } catch (error) {
        console.error('Error in media owner check:', error);
        setIsMediaOwner(false);
        setMediaOwnerName(null);
      }

      setChecking(false);
    };

    if (!loading) {
      checkMediaOwnerStatus();
    }
  }, [user, loading]);

  return { isMediaOwner, mediaOwnerName, checking };
};
